import { z } from 'zod';

const numberish = z
  .string()
  .min(1, 'Required')
  .regex(/^\d+$/, 'Numbers only');

const trunkCommon = {
  trunkName: z
    .string()
    .min(1, 'Trunk name is required')
    .max(120, 'Too long')
    .regex(/^[A-Za-z0-9_\- ]+$/, 'Letters, digits, spaces, _ and - only'),
  pilotNumber: z
    .string()
    .min(7, 'Pilot number is too short')
    .max(20, 'Too long')
    .regex(/^[+0-9]+$/, 'Digits and optional leading + only'),
  channels: numberish,
  cps: numberish,
};

/** Create — basic four fields. */
export const trunkCreateSchema = z.object(trunkCommon);
export type TrunkCreateInput = z.infer<typeof trunkCreateSchema>;

/** Update — adds the required `dialerId` linking field. */
export const trunkUpdateSchema = z.object({
  ...trunkCommon,
  dialerId: z.string().min(1, 'Pick a dialer'),
});
export type TrunkUpdateInput = z.infer<typeof trunkUpdateSchema>;
